export default __webpack_public_path__ + "static/updatedesk002-e49e5e847b3955f8755527d3dcf47c2e.png";